import { render, staticRenderFns } from "./Verification.vue?vue&type=template&id=a0a267aa&scoped=true&"
import script from "./Verification.vue?vue&type=script&lang=ts&"
export * from "./Verification.vue?vue&type=script&lang=ts&"
import style0 from "./Verification.vue?vue&type=style&index=0&id=a0a267aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a267aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VLayout,VRow})
